import React from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Profile: React.FC = () => {
  const { user } = useAuth();
  
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Profile
      </Typography>
      
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              disabled
              value={user?.email || ''}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Role"
              variant="outlined"
              disabled
              value={user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : ''}
            />
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Change Password
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="password"
              label="Current Password"
              variant="outlined"
            />
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="password"
              label="New Password"
              variant="outlined"
            />
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              type="password"
              label="Confirm New Password"
              variant="outlined"
            />
          </Grid>
          
          <Grid item xs={12}>
            <Button variant="contained" color="primary">
              Update Password
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Profile; 